module.exports = __webpack_public_path__ + "img/MILFormula.81b5e293.png";